// removed by extract-text-webpack-plugin
module.exports = {"specification":"specification__Ltf9Y-WA","item":"item__2-Luxkfj","itemName":"itemName__231D8ORE","btn":"btn__P28Hf_GF","checkbox":"checkbox__sQBJXyIb"};


//////////////////
// WEBPACK FOOTER
// ./src/components/OYFilter/components/OYSpecification/index.module.less
// module id = 691
// module chunks = 1